<template>
  <AppShell>
    <div class="page-head">
      <h1>Медиаматериал</h1>
      <v-btn color="primary" prepend-icon="mdi-folder-plus-outline" @click="editCatalog({})">Каталог</v-btn>
    </div>
    <div class="split-grid">
      <v-card variant="flat">
        <v-list density="compact">
          <v-list-item v-for="catalog in catalogs" :key="catalog.id" :active="selected?.id === catalog.id" :title="catalog.title" :subtitle="catalog.description" @click="selectCatalog(catalog)">
            <template #append><v-btn icon="mdi-pencil-outline" variant="text" size="small" @click.stop="editCatalog(catalog)" /></template>
          </v-list-item>
        </v-list>
      </v-card>
      <div>
        <v-card v-if="selected" variant="flat" class="pa-4 mb-4">
          <div class="catalog-toolbar">
            <v-file-input v-model="newItem.file" label="Картинка" accept="image/*" density="compact" hide-details prepend-icon="mdi-image-plus-outline" />
            <v-text-field v-model="newItem.title" label="Название" density="compact" hide-details />
            <v-combobox v-model="newItem.tags" label="Тэги" multiple chips density="compact" hide-details />
            <v-btn icon="mdi-plus" color="primary" :loading="uploading" :disabled="!newItem.file" @click="addItem" />
          </div>
        </v-card>

        <div v-if="selected" class="catalog-title-row">
          <div>
            <h2>{{ selected.title }}</h2>
            <p class="muted">{{ selected.description }}</p>
          </div>
          <v-chip variant="tonal" size="small">{{ items.length }} карт</v-chip>
        </div>

        <div v-if="items.length" class="gallery-grid">
          <MediaCard v-for="item in items" :key="item.id" :item="item" />
        </div>
        <v-card v-else-if="selected" variant="flat" class="empty-state">
          <v-icon icon="mdi-image-multiple-outline" size="36" />
          <div>В каталоге пока нет картинок</div>
        </v-card>
      </div>
    </div>
    <CatalogEditor v-model="editor" :catalog="draft" @save="saveCatalog" />
  </AppShell>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { api, unwrap } from '../api/http';
import AppShell from '../components/AppShell.vue';
import CatalogEditor from '../components/CatalogEditor.vue';
import MediaCard from '../components/MediaCard.vue';
const catalogs = ref([]);
const items = ref([]);
const selected = ref(null);
const editor = ref(false);
const draft = ref({});
const uploading = ref(false);
const newItem = reactive({ title: '', file: null, tags: [] });
async function loadCatalogs() { catalogs.value = unwrap(await api.get('/api/catalogs')); }
async function selectCatalog(catalog) { selected.value = catalog; items.value = unwrap(await api.get(`/api/catalogs/${catalog.id}/items`)); }
function editCatalog(catalog) { draft.value = { ...catalog }; editor.value = true; }
async function saveCatalog(form) {
  if (form.id) await api.put(`/api/catalogs/${form.id}`, form); else await api.post('/api/catalogs', form);
  editor.value = false;
  await loadCatalogs();
}
async function addItem() {
  if (!selected.value || !newItem.file) return;
  uploading.value = true;
  try {
    const formData = new FormData();
    formData.append('file', Array.isArray(newItem.file) ? newItem.file[0] : newItem.file);
    const uploaded = unwrap(await api.post('/api/uploads/images', formData, { headers: { 'Content-Type': 'multipart/form-data' } }));
    await api.post(`/api/catalogs/${selected.value.id}/items`, {
      title: newItem.title || uploaded.original_name,
      image_url: uploaded.image_url,
      tags: newItem.tags,
    });
    Object.assign(newItem, { title: '', file: null, tags: [] });
    await selectCatalog(selected.value);
  } finally {
    uploading.value = false;
  }
}
onMounted(loadCatalogs);
</script>
